<template>
  <div>
    <serveur-info :erreur="error" />
    <form @submit.prevent="validateBeforeSubmit">
      <my-notification :icon="ICON">
        <template #title>
          {{ $t('compAdminEntityEntity.title-1') }}
        </template>
        {{ $t('compAdminEntityEntity.info-1') }}
      </my-notification>
      <br />
      <entity-form v-model="entity" @input="inputChanged" />
      <br />
      <nav class="level">
        <div class="level-left"></div>
        <div class="buttons level-right">
          <b-button
            class="button"
            @click="initEntity"
            :disabled="resetDisabled"
            icon-left="close"
          >
            {{ $t('cancel') }}
          </b-button>
          <button
            type="submit"
            :disabled="saveDisabled"
            class="level-item button is-primary"
          >
            <span class="icon is-small"><i class="fa fa-save"></i></span>
            <span>{{ $t('save') }}</span>
          </button>
        </div>
      </nav>
    </form>
  </div>
</template>

<script>
import { useAdminStore } from '@/stores/admin.js'
import { Entity } from '@/models/core'

export default {
  name: 'Entity',
  components: {
    'serveur-info': () => import('@/components/ServeurInfo.vue'),
    'entity-form': () => import('@/components/admin/entity/EntityForm.vue'),
    'my-notification': () => import('@/components/MyNotification.vue')
  },
  props: {
    loaded: {
      type: Boolean,
      required: false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      error: '',
      hasChanged: false,
      entity: Entity.createEmpty()
    }
  },
  setup () {
    const adminStore = useAdminStore()
    return { adminStore }
  },
  computed: {
    savedEntity: function () {
      return this.adminStore.entity
    },
    ICON: function () {
      return Entity.ICON
    },
    resetDisabled: function () {
      let toReturn = true
      if (this.entity.id !== null) {
        toReturn = !this.hasChanged
      } else {
        toReturn = true
      }
      return toReturn
    },
    saveDisabled: function () {
      return false
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const loadingComponent = this.$buefy.loading.open({
            container: null
          })
          this.adminStore
            .saveEntity(Entity.createFromObj(this.entity))
            .then((data) => {
              loadingComponent.close()
              window.scrollTo(0, 0)
              this.$buefy.toast.open({
                type: 'is-light',
                message: this.$t('compAdminEntityEntity.save-msg')
              })
            })
            .catch((error) => {
              this.initEntity()
              loadingComponent.close()
              this.error = error.response.data
            })
        }
      })
    },
    initEntity () {
      this.hasChanged = false
      this.error = ''
      this.entity = Entity.createFromObj(Object.assign({}, this.savedEntity))
    },
    inputChanged () {
      this.hasChanged = true
    }
  },
  watch: {
    loaded: function () {
      this.initEntity()
    }
  },
  mounted () {
    this.initEntity()
  }
}
</script>
